export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const FORMDATA_DETAILS = "FORMDATA_DETAILS";
export const EMPLOYEE_DETAILS = "EMPLOYEE_DETAILS";
export const COPYDOC_DETAILS = "COPYDOC_DETAILS";
export const LOGOUT = "LOGOUT";
export const PL = "PL";
export const PLSTATUS = "PLSTATUS";
export const PLSTAPLSTATUSDISACTIVETUS = "PLSTATUSDISACTIVE";
export const LOGIN_DATA = "LOGIN_DATA";
// export const LOGOUT = "LOGOUT";